module.exports = __webpack_public_path__ + "img/about_banner.ce568257.jpg";